
import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section className="relative h-screen w-full flex items-center justify-center overflow-hidden bg-neutral-950">
      {/* Background Image with Parallax-like slow scale */}
      <motion.div 
        className="absolute inset-0 z-0"
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 10, ease: "easeOut" }}
      >
        <div className="absolute inset-0 bg-neutral-950/60 z-10" /> {/* Dark Overlay */}
        <img 
          src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=2070&auto=format&fit=crop" 
          alt="Modern Architecture Rendering" 
          className="w-full h-full object-cover object-center"
        />
      </motion.div>

      {/* Content */}
      <div className="relative z-20 text-center px-6 max-w-5xl mx-auto mt-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          <span className="text-neutral-400 uppercase tracking-[0.3em] text-sm md:text-base mb-6 block">
            Architectural Visualisation Studio
          </span>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-light text-white leading-tight mb-8">
            Unbuilt <br className="hidden md:block"/> 
            <span className="font-semibold italic font-serif">Realities.</span>
          </h1>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.8 }}
        >
          <p className="text-neutral-300 text-lg md:text-xl max-w-2xl mx-auto mb-12 font-light">
            We craft photorealistic 3D renderings that breathe life into architectural concepts before ground is ever broken.
          </p>
          
          <a 
            href="#portfolio"
            className="inline-block border border-white/30 text-white px-8 py-4 uppercase tracking-widest text-sm hover:bg-white hover:text-black transition-all duration-300"
          >
            Explore Selected Works
          </a>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div 
        className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
      >
        <span className="text-white/50 text-xs uppercase tracking-widest mb-2">Scroll</span>
        <div className="w-[1px] h-12 bg-white/20 relative overflow-hidden">
          <motion.div 
            className="w-full h-full bg-white absolute top-0"
            animate={{ y: ['-100%', '100%'] }}
            transition={{ repeat: Infinity, duration: 2, ease: "linear" }}
          />
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
